// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__sEFAm","ellipsis":"P_ellipsis__PUJFA","hoverEnabled":"P_hoverEnabled__Kjk7h","selected":"P_selected__ZKFR9","textHover":"P_textHover__0qjUx"};